import React, { useRef } from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../../components/headers/Header";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
// import PinyinInput from "../../../components/ui/PinyinInput";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
//import * as Helper from "../../../../utils/Helper"

import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/dictionary/radical/EditRedux";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import { NavigationService } from "../../../../navigation";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.dictionary.radical.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_RADICAL_ASYNC]: {
                done: this._handleSaveRadicalAsyncDone,
                error: this._handleAsyncActionError
            }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.createRadical();
    }

    render() {
        const { radical } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!radical || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC) || this.isActionExecuting(ActionTypes.SAVE_RADICAL_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    radical={radical}
                                    onSave={this._handleSaveRadical}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSaveRadical = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
						this.props.saveRadicalAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    };

    _handleSaveRadicalAsyncDone = () => {
        NavigationService.navigateToPageByUID(this, UIDs.screens.admin.dictionary.radical.list, null);
    };

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    };
}

function EditForm(props) {
    const { radical } = props;
    const { id, numOfStrokes } = radical;
    const { register, handleSubmit, errors } = useForm();
    const submitRef = useRef();

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("radical")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            tag={Link}
                            to={NavigationService.getPathNameByUID(UIDs.screens.admin.dictionary.radical.list)}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("id")}</label>
                                    <textarea rows="3" disabled={!!id} name="id" type="text"
                                        className="form-control-alternative form-control" defaultValue={id}
                                        ref={register({ required: true })} />
                                    {errors.id && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("numOfStrokes")}</label>
                                    <input name="numOfStrokes" className="form-control-alternative form-control"
                                        defaultValue={numOfStrokes}
                                        ref={register({ required: true })} />
                                    {errors.numOfStrokes && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: radical => dispatch(Actions.loadScreenViewAsync(radical)),
        saveRadicalAsync: vo => dispatch(Actions.saveRadicalAsync(vo)),
        createRadical: () => dispatch(Actions.createRadical()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
